var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpcomingSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3771_24051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.5234 15.5234 20 10 20C4.47656 20 0 15.5234 0 10C0 7.91797 0.635938 5.98438 1.72461 4.38281C1.91875 4.09766 2.30742 4.02344 2.59258 4.21875C2.87813 4.37891 2.95234 4.80078 2.7582 5.08594C1.80625 6.48828 1.25 8.17969 1.25 10C1.25 14.832 5.16797 18.75 10 18.75C14.832 18.75 18.75 14.832 18.75 10C18.75 5.37891 15.1641 1.59258 10.625 1.27188V4.375C10.625 4.71875 10.3438 5 10 5C9.65625 5 9.375 4.71875 9.375 4.375V0.625C9.375 0.279844 9.65625 0 10 0C15.5234 0 20 4.47656 20 10ZM10.4414 9.55859C10.6875 9.80078 10.6875 10.1992 10.4414 10.4414C10.1992 10.6875 9.80078 10.6875 9.55859 10.4414L5.80859 6.69141C5.5625 6.44922 5.5625 6.05078 5.80859 5.80859C6.05078 5.5625 6.44922 5.5625 6.69141 5.80859L10.4414 9.55859Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3771_24051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingSvg);
export default __webpack_public_path__ + "static/media/upcomingSvg.bf1e5ada379e0ab218d9270725594816.svg";
export { ForwardRef as ReactComponent };